exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minimize-link[data-v-53771385]{margin:0 4px;float:left}.palette-link[data-v-53771385]{margin:0 4px;float:right}", ""]);

// exports
